<template>
  <div id="wt-layout-login">
    <div id="wt-layout-login-left"></div>
    <div id="wt-layout-login-right">
      <div id="wt-layout-login-right-header">
        <img src="@/assets/img/login/logo.png" />
      </div>      
      <div id="wt-layout-login-right-main">
        <div class="form-signin">
          <p class="mt-2 mb-3 text-center failure">{{tenant.tenant_name}}</p>
          <h3 class="mt-2 mb-3 text-center">SIGN IN</h3>
          <b-form>
          
          <div class="mb-3">
            <label for="access_key" class="sr-only">User</label>
            <input
              type="text"
              autocomplete="user"
              id="access_key"
              class="form-control"
              placeholder="ACCESS KEY"
              required
              autofocus
              v-model="authorization.access_key"
            />
          </div>
          <div class="mb-3">
            <label for="secret_key" class="sr-only">Password</label>
            <input
              type="password" 
              autocomplete="current-password"
              id="secret_key"
              class="form-control"
              placeholder="PASSWORD"
              required
              v-model="authorization.secret_key"
              v-on:keyup.enter="signin"
            />
          </div>
          <div class="checkbox mb-3">
            <label>
              <input type="checkbox" value="remember-me" /> Remember me
            </label>
          </div>
          <div>
            <b-button size="lg" pill block variant="primary" @click="signin">ENTRAR</b-button>
          </div>
          </b-form>
        </div>
      </div>
      <div id="wt-layout-login-right-footer">
        <strong class="failure">{{statusAutenticacao}}</strong>
      </div>
    </div>
  </div>
</template>

<script>
import { baseApiUrl, userKey } from "@/global";
import axios from "axios";

export default {
  name: "Signin",
  props: {
    isVisible: Boolean
  },
  components: {},
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    tenant() {
      return this.$store.state.auth.tenant;
    }
  },
  data() {
    return {
      urlservices: "authorization/v01/authentication/authorization",
      authorization: {},
      rauthorization: [],
      statusAutenticacao: "",
    };
  },
  methods: {
    signin() {
      this.statusAutenticacao = "aguarde...";
      /* Adicionando o SN no header */
      axios.defaults.headers.common['sn'] = this.tenant.serial_number
      axios.post(`${baseApiUrl}/${this.urlservices}`,this.authorization)
      
        .then(res => {
          this.$store.commit("setUser",Object.assign({}, res.data, this.authorization));
          localStorage.setItem(userKey, JSON.stringify(this.user));
          console.clear();
          this.$router.push({ name: "system-menu" });
        })
        .catch(error => {
          this.statusAutenticacao = `Failure: ${error.response.data}`;
        });
    }
  },
  created() {
    this.$store.commit("setTypeLayout", 1);

  }
};
</script>

